var React = require('react');

function Gallery (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.727 2.273a1 1 0 0 0-1-1H2.273a1 1 0 0 0-1 1v8.697L3.54 6.86a1 1 0 0 1 1.64-.162L7.64 9.61a1 1 0 0 0 1.227.24l2.23-1.167a1 1 0 0 1 1.22.23l2.41 2.78v-9.42zM2.273 14.727a1 1 0 0 1-1-1v-.121L3.76 9.094a1 1 0 0 1 1.64-.162l1.925 2.279a1 1 0 0 0 1.227.24l2.243-1.174a1 1 0 0 1 1.22.231l2.711 3.126v.093a1 1 0 0 1-1 1H2.273zM1 0a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1zm10.727 6.545a1.818 1.818 0 1 0 0-3.636 1.818 1.818 0 0 0 0 3.636z","fill":"#262626"}));
}

Gallery.defaultProps = {"width":"16","height":"16","fill":"none"};

module.exports = Gallery;

Gallery.default = Gallery;
